// Menu.js
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import "./Menu.css";
import { Link } from "react-router-dom";
import Close from "../../assets/imgs/close.svg";

import { useAuth } from "../../services/context/AuthContext";

const Menu = ({ toggleSidebar, isOpen, setIsOpen }) => {
  const sidebarRef = useRef(null);
  const navigate = useNavigate();

  const { user } = useAuth();
  const manualRouting = (address) => {
    navigate(address);
    toggleSidebar();
  };

  const closeSidebar = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const scrollToTop = () => {

    toggleSidebar();
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scroll behavior
    });
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeSidebar);
    return () => {
      document.removeEventListener("mousedown", closeSidebar);
    };
  });

  const main = process.env.REACT_APP_MAIN;

  return (
    <>
      <CSSTransition in={isOpen} timeout={500} classNames="fade" unmountOnExit>
        <div>
          <div className="sidebar" ref={sidebarRef}>
    
            <div className="offcanvas-header">
              <h5 className="offcanvas-title mb-4">Menu</h5>
              <button className="btn-close" onClick={toggleSidebar}></button>
            </div>
            <div className="offcanvas-body">
              <nav className="nav flex-column menu-nav">
                <button className="btn btn-outline-primary mb-2" onClick={() => manualRouting(main)}>
                  Início
                </button>
                <button className="btn btn-outline-primary mb-2" onClick={() => manualRouting(main + "livros")}>
                  Livros
                </button>
                <button className="btn btn-outline-primary mb-2" onClick={() => manualRouting(main + "contato")}>
                  Contato
                </button>
                {user ? (
                  <Link className="btn btn-outline-primary" style={{ color: "#0d6efd !important" }} to={main + "perfil"} onClick={scrollToTop}>
                    Perfil
                  </Link>
                ) : (

                    <Link className="btn btn-outline-primary" style={{ color: "#0d6efd !important" }} to={main + "login"} onClick={scrollToTop}>
                    Login
                  </Link>

                )}
              </nav>
            </div>
          </div>
          <div className="curtain"></div>
        </div>
      </CSSTransition>
    </>
  );
};

export default Menu;
